// API Configuration
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3003'

export const apiConfig = {
    baseURL: API_BASE_URL,
    endpoints: {
        health: '/api/health',
        analytics: {
            simple: '/api/analytics/simple',
            comprehensive: '/api/analytics/comprehensive',
            lastUpdate: '/api/analytics/last-update'
        },
        upload: {
            excel: '/api/upload/excel',
            history: '/api/upload/history'
        },
        insights: {
            test: '/api/insights/test',
            quick: '/api/insights/quick',
            chat: '/api/insights/chat'
        }
    }
}

// Helper function to build full URL
export const buildApiUrl = (endpoint: string): string => {
    // In development, use relative URLs (proxy handles it)
    // In production, use full URLs
    if (import.meta.env.DEV) {
        return endpoint
    }
    return `${API_BASE_URL}${endpoint}`
}

// Helper function for API calls
export const apiCall = async (endpoint: string, options?: RequestInit) => {
    const url = buildApiUrl(endpoint)
    return fetch(url, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    })
}